module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "ch00_fm07_note"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('strong', [_vm._v("Publisher’s Note")])]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("This book is not intended as a substitute for medical advice. Readers are encouraged to consult with a doctor before following this or any other dietary advice."), _c('a', {
    attrs: {
      "id": "page_16"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ba3f8c7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm07_note.vue
// module id = 78
// module chunks = 0